module.exports = __webpack_public_path__ + "img/dashboard-mockup-2.1bce81b1.png";